import { ButtonBase, Card, CardContent, Grid, Typography } from '@material-ui/core';
import cx from 'classnames';
import { useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { initVehicleDetailsData } from '../../actions/vehicles';
import { MOBILE_BREAKPOINT } from '../../constants';
import ArrowLeft from '../../img/Left Arrow.svg';
import ArrowRight from '../../img/Right Arrow.svg';
import NextIcon from '../../img/auction-order/next.svg';
import PriorIcon from '../../img/auction-order/prior.svg';
import { AUTSlider } from '../index';
import InfoElement from './InfoElement';
import { CarListView } from './ListView';
import './index.scss';
import { CaretDown, CaretUp, MyBidsIcon } from '../../components/Icons';
import { ReservePriceLabel } from 'components/ReservePriceMet';
import { formatCurrency } from 'utils';
import { useWindowSize } from 'usehooks-ts';
import { useHistory } from 'react-router-dom';
import { DealInfo } from './DealInfo';
import { HoverView } from './HowerView';

const StyledTyporgraphyPerks = styled(Typography)`
  && {
    font-size: 14px;
  }
`;

const TypographyWithMinHeight = styled(Typography)`
  && {
    // min-height: 64px;
    font-size: 18px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const MyBidsIconWrapper = styled.div`
  top: 8px;
  left: -4px;
  z-index: 99;
  overflow: visible;
  position: absolute;
`;

const BidInfoContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const HoverWrapper = styled.div`
  display: ${({ isExpanded }) => (isExpanded ? 'flex' : 'none')};
  margin-top: 30px;
  padding-top: 8px;
  border-top: 1px solid #e5e5e5;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const CaretIconWrapper = styled.div`
  display: ${props => (props.hidden ? 'none' : 'flex')};
  justify-content: center;
  margin-top: 12px;
`;

const ImageWrapper = styled.div`
  position: relative;
`;

const StyledButtonWrapper = styled(ButtonBase)`
  position: relative;

  && {
    display: block;
    width: 100%;
    text-align: initial;
  }
`;

const ReserveLabelWrapper = styled.div`
  padding-bottom: 8px;
`;

const ReservePlaceholder = styled.div`
  height: 17px;
  width: 100%;
`;

const BluebookRow = styled.div`
  font-size: 14px;
  color: rgb(97, 97, 97);
  padding-top: 8px;
`;

const CarCard = ({ vehicle, withHover, listView: initialListView = false }) => {
  const { width = 0, height = 0 } = useWindowSize();

  const buyNowRef = useRef();

  const user = useSelector(state => state.user?.user);
  const history = useHistory();

  const [isExpanded, setIsExpanded] = useState(false);
  const isMobile = width <= MOBILE_BREAKPOINT;
  const isLoggedIn = user && user.id;

  const dispatch = useDispatch();

  const onClick = () => {
    history.push(`/vehicles/${vehicle.id}/details`);
    dispatch(initVehicleDetailsData(vehicle));
  };

  const onMouseOver = e => {
    if (buyNowRef.current && buyNowRef.current.contains(e.target)) {
      return;
    }

    if (!initialListView && !isMobile) {
      setIsExpanded(true);
    }
  };

  const onMouseOut = () => {
    if (isMobile) return;
    setIsExpanded(false);
  };

  const toggleExpand = () => setIsExpanded(prev => !prev);

  let listView = initialListView;
  // if (['md', 'sm', 'xs'].includes(width)) {
  //   listView = false;
  // }

  const vehicleName = `${vehicle.year} ${vehicle.make} ${vehicle.model}`;
  const myBid = vehicle.my_bid;
  const vehicleImages = (vehicle.images || []).slice(0, 3);
  const iconByType = {
    prior: PriorIcon,
    next: NextIcon
  };

  const RenderReservePriceComponent = useCallback(() => {
    return (
      <ReserveLabelWrapper>
        {vehicle.reserve_price_set ? <ReservePriceLabel size="sm" activeVehicle={vehicle} /> : <ReservePlaceholder />}
      </ReserveLabelWrapper>
    );
  }, [vehicle, user]);

  const vehicleBookMileage = `Book: ${formatCurrency(vehicle.bluebook_mileage)}/ miles: ${formatCurrency(
    vehicle.mileage
  ).slice(1)}`;

  const isAlternativeAuction = vehicle.auction.type !== 'autoaxess';
  const buyNowVisible = vehicle.active_alternative_offer && isAlternativeAuction && !isExpanded;

  const minHeight = (() => {
    if (listView || isMobile) return 'initial';
    if (user && user.role === 'buyer') {
      return '430px';
    }
    return '430px';
  })();

  return (
    <div style={{ position: 'relative' }}>
      {vehicle.iconType && (
        <div className="label-image">
          <img src={iconByType[vehicle.iconType]} alt={vehicle.iconType} />
        </div>
      )}
      <Card
        square
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseOut}
        className={`car-card ${listView ? 'list-view' : ''}`}
        style={{
          display: listView ? 'flex' : 'block',
          flex: 'auto',
          position: 'relative',
          minHeight
        }}
      >
        <div
          className="slider-container vehicles-images"
          onClick={onClick}
          onKeyPress={e => {
            if (e.target && e.target.className === 'car-card-image') {
              onClick();
            }
          }}
          role="button"
          tabIndex={0}
        >
          <AUTSlider
            settings={{
              arrows: true,
              dots: true,
              draggable: false,
              nextArrow: <img src={ArrowRight} alt="next" />,
              prevArrow: <img src={ArrowLeft} alt="prev" />
            }}
          >
            {vehicleImages.map((vehicleImage, i) => (
              <ImageWrapper key={i}>
                {myBid && (
                  <MyBidsIconWrapper>
                    <MyBidsIcon />
                  </MyBidsIconWrapper>
                )}
                <div
                  className={cx('car-card-image', { listView })}
                  style={{
                    backgroundImage: `url(${vehicleImage.url_thumb})`,
                    gridRow: '1 / 2',
                    gridColumn: '1 / 2'
                  }}
                />
              </ImageWrapper>
            ))}
          </AUTSlider>
        </div>
        {listView ? (
          <CarListView vehicle={vehicle} />
        ) : (
          <StyledButtonWrapper>
            <CardContent className="lot-info">
              <RenderReservePriceComponent />
              <TypographyWithMinHeight gutterBottom variant="headline" component="h2" title={vehicleName}>
                {vehicleName}
              </TypographyWithMinHeight>
              <Grid container direction="column" style={{ color: '#616161' }}>
                {isMobile ? (
                  <BluebookRow>{vehicleBookMileage}</BluebookRow>
                ) : (
                  <InfoElement isGridView type="miles" item="Miles" value={vehicle.mileage} />
                )}
                {isLoggedIn && !isMobile && (
                  <>
                    <InfoElement nowrap type="miles" item="Value Without Miles Adj" value={vehicle.bluebook_value} />
                    <InfoElement nowrap type="miles" item="Blue Book® Lending Value" value={vehicle.bluebook_mileage} />
                  </>
                )}
                <DealInfo buyNowRef={buyNowRef} vehicle={vehicle} isExpanded={isExpanded && withHover} />
                {user?.role === 'buyer' && <HoverView vehicle={vehicle} isExpanded={isExpanded && withHover} />}
                {isMobile && withHover && (
                  <>
                    <CaretIconWrapper hidden={!isExpanded} onClick={toggleExpand}>
                      <CaretUp />
                    </CaretIconWrapper>
                    <CaretIconWrapper hidden={isExpanded} onClick={toggleExpand}>
                      <CaretDown />
                    </CaretIconWrapper>
                  </>
                )}
              </Grid>
            </CardContent>
          </StyledButtonWrapper>
        )}
      </Card>
    </div>
  );
};

export default CarCard;
